
import { useEffect } from 'react';

export default function MaintenancePage() {
  useEffect(() => {
    document.title = 'Site Maintenance - QBOVerifier';
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-12 text-center">
          {/* Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-tools-fill text-white text-5xl"></i>
          </div>

          {/* Title */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            We'll Be Back Soon!
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            We're currently performing scheduled maintenance to improve your experience. 
            Our site will be back online shortly.
          </p>

          {/* Status */}
          <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-6 mb-8">
            <div className="flex items-center justify-center gap-3 mb-3">
              <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
              <span className="text-lg font-semibold text-gray-900">Maintenance in Progress</span>
            </div>
            <p className="text-gray-600">
              Expected completion: We'll be back as soon as possible
            </p>
          </div>

          {/* Contact Info */}
          <div className="border-t border-gray-200 pt-8">
            <p className="text-gray-600 mb-4">
              Need immediate assistance?
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="mailto:support@qboverifier.com"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg font-semibold hover:from-blue-600 hover:to-indigo-700 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                Email Support
              </a>
              <a 
                href="tel:+1234567890"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-blue-500 text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                Call Us
              </a>
            </div>
          </div>

          {/* Social Links */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-gray-600 mb-4">Stay connected with us:</p>
            <div className="flex justify-center gap-4">
              <a 
                href="https://twitter.com/qboverifier" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gray-100 hover:bg-blue-500 text-gray-600 hover:text-white rounded-full flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a 
                href="https://facebook.com/qboverifier" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gray-100 hover:bg-blue-500 text-gray-600 hover:text-white rounded-full flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://linkedin.com/company/qboverifier" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 bg-gray-100 hover:bg-blue-500 text-gray-600 hover:text-white rounded-full flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-gray-600 mt-8">
          Thank you for your patience and understanding.
        </p>
      </div>
    </div>
  );
}
